
import * as React from 'react';
import Typography from '@mui/material/Typography';
import { Button, Card, CardActions, CardContent, CardMedia, Container, Divider, Grid, List, ListItem, ListItemIcon, ListItemText, Paper, Stack, styled } from '@mui/material';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';


const items = [
    {title:"Contact Us",description:"With our state-of-the-art app, find and reserve your perfect spot in seconds. Say hello to parking bliss!"},
    {title:"Chat",description:"9:30 AM - 8:30 PM EST 7 Days a Week"},
    {title:"Message",description:"ext (618) 867.4225 9:30 AM - 8:30 PM EST 7 Days a Week"},
]

const values = [
    "Innovation – We embrace technology to create smarter, faster, and simpler solutions.",

    "Security – We prioritize the safety of users, data, and access at every level.",

    "Efficiency – We streamline operations for businesses and users through intelligent automation.",

    "Transparency – We build trust with honest communication and reliable service.",

    "Customer Focus – We design every experience around real user needs and satisfaction.",
]

export default function AboutUs() {
    return (
        <>
            <Container id = "app" maxWidth = {'xl'}  component='main'>
                <Divider sx={{my:8}}></Divider>
                <Grid container columns={12} sx={{pt:8}}>
                    <Grid item xs={1} md ={1} sm={1} align="left" />  
                    
                    <Grid item xs={10} md ={5} sm={5} align="left" >  
                        <Stack spacing={2} >
                            <Typography component="p"  variant="h3" color="black" sx={{fontWeight:'bolder'}} >
                            About Us
                            </Typography>
                            <Typography variant="body1" gutterBottom color="black">
    
                            We are a technology-driven company focused on revolutionizing the parking experience through smart, digital solutions. Our services integrate automation, security, and convenience to provide seamless parking access and management for individuals, businesses, and property administrators. With cutting-edge systems and user-centric platforms, we simplify urban mobility and facility operations.
                            </Typography>
                        </Stack> 
                    </Grid>

                    <Grid item xs={10} md ={5} sm={5} align="right" >  
                        <img
                            width="296"
                            height="409" 
                            src="https://firebasestorage.googleapis.com/v0/b/demos-a64ab.appspot.com/o/landing%2Fhand_app.png?alt=media&token=364790ef-d870-4053-bbc7-c0189fca4eb7"
                            alt="Live from space album cover"
                        />            
                    </Grid>
                    
                    <Grid item xs={1} md ={1} sm={1} align="left" />  
                </Grid>
            </Container>

            <Container id = "app" maxWidth = {'xl'}  component='main' sx={{background:"#fafafa"}}>
                <Grid container columns={12} sx={{pt:8}}>
                    <Grid item xs={1} md ={1} sm={1}/>  
                    <Grid item xs={10} md ={5} sm={5} align="left" >  
                        <img
                              width="420"
                              height="256" 
                            src="https://firebasestorage.googleapis.com/v0/b/demos-a64ab.appspot.com/o/landing%2Fbackgroundparking.png?alt=media&token=eda48dfa-0d68-4235-bcdb-8225f10a3785"
                            alt="Live from space album cover"
                        />            
                    </Grid>
                    <Grid item xs={10} md ={5} sm={5} align="left" >  
                        <Stack spacing={2} >
                            <Typography component="p"  variant="h3" color="black" sx={{fontWeight:'bolder'}} >
                            Mission
                            </Typography>
                            <Typography variant="body1" gutterBottom color="black">
                            To transform parking and access control through innovative digital solutions that enhance efficiency, security, and convenience for every user.
                            </Typography>
                        </Stack> 
                    </Grid>   
                    <Grid item xs={1} md ={1} sm={1} />  
                </Grid>
            </Container>

            <Container id = "app" maxWidth = {'xl'}  component='main' sx={{background:"#fafafa"}}>
                <Grid container columns={12} sx={{pt:8}}>
                    <Grid item xs={1} md ={1} sm={1}/>  
                    <Grid item xs={10} md ={5} sm={5} align="left" >  
                        <Stack spacing={2} >
                            <Typography component="p"  variant="h3" color="black" sx={{fontWeight:'bolder'}} >
                            Vision
                            </Typography>
                            <Typography variant="body1" gutterBottom color="black">
                            To be a leading provider of smart parking and digital infrastructure in Latin America, recognized for driving sustainable, connected, and intelligent urban environments.
                            </Typography>
                        </Stack> 
                    </Grid>  
                    <Grid item xs={10} md ={5} sm={5} align="right" >  
                        <img
                            width="420"
                            height="256" 
                            src="https://firebasestorage.googleapis.com/v0/b/demos-a64ab.appspot.com/o/landing%2Fbackgroundparking.png?alt=media&token=eda48dfa-0d68-4235-bcdb-8225f10a3785"
                            alt="Live from space album cover"
                        />            
                    </Grid> 
                    <Grid item xs={1} md ={1} sm={1} />  
                </Grid>
            </Container>

            <Container id = "app" maxWidth = {'xl'}  component='main' sx={{background:'linear-gradient(135deg, #ffab00 0%, #ffab00 50%, #ff8f00 100%);'}}>
                <Grid container columns={12} sx={{py:8}}>
                    <Grid item xs={1} md ={1} sm={1} align="left" />  
                    
                    <Grid item xs={10} md ={10} sm={10} align="left" >  
                        <Stack spacing={2} >
                            <Typography component="p"  variant="h3" color="black" sx={{fontWeight:'bolder'}} >
                            Core Values
                            </Typography>
                            <List>
                                    {values.map((item, index) => (
                                        <ListItem key={index}>
                                        <ListItemIcon>
                                            <FiberManualRecordIcon fontSize="small" />
                                        </ListItemIcon>
                                        <ListItemText primary={item} />
                                        </ListItem>
                                    ))}
                                </List>
                        </Stack> 
                    </Grid>
                    
                    <Grid item xs={1} md ={1} sm={1} align="left" />  
                </Grid>
            </Container>
        </>
    );
}